export const bar = state => state.page.bar

export const isFetching = state => state.page.isFetching

export const style = state => state.page.style

export const isModalView = state => state.page.isModalView
